import { createStyles, Grid, TextField, Theme, withStyles, WithStyles } from '@material-ui/core'
import * as React from 'react'

interface WagesAnnuallyProps extends WithStyles<typeof styles> {
	jobPlacementWeeklyHours?:number
	jobPlacementWage?:number
  perDiem?:string
  jobPlacementWageFrequency?:string
}

const WagesAnnually: React.FC<WagesAnnuallyProps> = (props: WagesAnnuallyProps) => {
	const { classes, jobPlacementWage,jobPlacementWageFrequency,jobPlacementWeeklyHours,perDiem } = props
  let wagesAnnually: number
  let wagesAnnuallyUSD: string | number = '-'
    switch(jobPlacementWageFrequency){
      case 'HOUR':
        wagesAnnually = jobPlacementWage * jobPlacementWeeklyHours * 52
        break
      case 'WEEK':
        wagesAnnually = jobPlacementWage * 52
        break
      case 'YEAR':
        wagesAnnually = parseInt(jobPlacementWage+"")
        break
    }

    if(isNaN(wagesAnnually)){
      wagesAnnuallyUSD='-'
    }
    else{
      wagesAnnuallyUSD = wagesAnnually.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        // maximumFractionDigits: 2,
        // minimumFractionDigits: 0,
      })
    }
	return (
		<Grid container={true} spacing={8}>
			<Grid item={true} xs={12} md={3} className={classes.dropdownLabel}>
				Wages Annually&#58; 
			</Grid>
			<Grid item={true} xs={6} sm={4}>
        <div className={classes.wagesAnnually}>
          {wagesAnnuallyUSD}
        </div>
				{/* <TextField
					name="jobPlacementWagesAnnually"
					required={false}
					className={classes.dropdown}
					value={wagesAnnuallyUSD}
					disabled= {true}
					margin="dense"
					variant="outlined"
				/> */}
			</Grid>
		</Grid>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		dropdownLabel: {
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'center',
			paddingTop: '12px',
			[theme.breakpoints.down('sm')]: {
				justifyContent: 'flex-start',
			},
		},
		dropdown: {
			display: 'flex',
			flex: 1,
		},
    wagesAnnually:{
      marginTop:'1em',
      marginBottom:'1em'
    }
	})

export default withStyles(styles)(WagesAnnually)
